import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import ScrollToTop from '../../hoc/ScrollToTop';
import { updateViewportHeight } from '../../utils/functions';
import { getMobileStepsData } from '../../actions/steps';
import { getUserExisting } from '../../actions/auth';
import Preloader from '../../components/Preloader/Preloader';
import Login from '../Login/Login';
import Registration from '../Registration/Registration';
import ResetPassword from '../ResetPassword/ResetPassword';
import GetMealPlan from '../GetMealPlan/GetMealPlan';
// import Dashboard from '../Dashboard/Dashboard';
import Dashboard from '../Dashboard/Dashboard';
import Menu from '../Menu/Menu';
import Terms from '../Terms/Terms';
import Dev from '../Dev/Dev';
import Privacy from '../Privacy/Privacy';
import ConfirmEmail from '../ConfirmEmail/ConfirmEmail';
import PageNotFound from '../PageNotFound/PageNotFound';
// import Basket from '../Basket/Basket';
import BasketProducts from '../BasketProducts/BasketProducts';
import GetApp from '../GetApp/GetApp';
import BlogList from '../BlogList/BlogList';
import Blog from '../Blog/Blog';
import Support from '../Support/Support';
import Contact from '../Contact/Contact';
import Popup from '../../components/Popup/Popup';
import ProgressPage from '../../components/ProgressPage/ProgressPage';

import styles from './App.module.css';

function App (props) {
  const { 
    isFetching, 
    userData,
    getMobileStepsData,
    getUserExisting,
   } = props;

  useEffect(() => {
    updateViewportHeight();
  }, []);

  useEffect(() => {
    if (userData) {
      getUserExisting();
      getMobileStepsData();
    }
  }, [userData]);

  const renderCommonRoutes = () => (
    <>
      <Route exact path="/terms" Component={Terms} />
      <Route exact path="/privacy" Component={Privacy} />
      <Route exact path="/progress" Component={ProgressPage} />
      <Route exact path="/support" Component={Support} />
      <Route exact path="/contact" Component={Contact} />
      <Route exact path="/confirm-email" Component={ConfirmEmail} />
      <Route exact path="/get-app" Component={GetApp} />
      <Route exact path="/blog" Component={BlogList} />
      <Route exact path="/blog/:id" Component={Blog} />
      <Route path="*" Component={PageNotFound}/>
    </>
  );

  // console.log('===userData', userData);

  if (userData) {
    const HomePage = userData?.user?.balanced_menu_generated
      ? Menu
      : Dashboard;

    return (
      <div className={styles.wrapper}>
        {isFetching && <Preloader/>}
        <Popup />
        <Toaster />
        <ScrollToTop />
        <Routes>
          <Route exact path="/" Component={HomePage} />
          <Route exact path="/edit" Component={Dashboard} />
          {/* <Route exact path="/basket" Component={Basket} /> */}
          <Route exact path="/basket" Component={BasketProducts} />
          {renderCommonRoutes()}
        </Routes>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {isFetching && <Preloader/>}
      <Popup />
      <Toaster />
      <ScrollToTop />
      <Routes>
        <Route exact path="/" Component={Dev} />
        <Route exact path="/get-meal-plan" Component={GetMealPlan} />
        <Route exact path="/login" Component={Login} />
        <Route exact path="/register" Component={Registration} />
        <Route exact path="/reset-password" Component={ResetPassword} />
        {renderCommonRoutes()}
      </Routes>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isFetching: state.preloader.isFetching,
  userData: state.auth.userData,
});

const mapDispatchToProps = {
  getMobileStepsData,
  getUserExisting,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);